<template>
  <div class="crm-empty-state">
    <div v-if="icon" class="crm-empty-icon">
      <i :class="icon"></i>
    </div>
    <strong>{{ title }}</strong>
    <p v-if="description">{{ description }}</p>
    <div v-if="$slots.action" class="crm-empty-action">
      <slot name="action"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "CrmEmptyState",
  props: {
    description: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "la la-inbox",
    },
    title: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.crm-empty-state {
  align-items: center;
  background: #f8fafc;
  border: 1px dashed #cad4e4;
  border-radius: 8px;
  color: #25324b;
  display: flex;
  flex-direction: column;
  gap: 7px;
  justify-content: center;
  min-height: 126px;
  padding: 18px;
  text-align: center;
  width: 100%;
}

.crm-empty-icon {
  align-items: center;
  background: #eaf7ff;
  border-radius: 50%;
  color: #0b87c9;
  display: inline-flex;
  height: 34px;
  justify-content: center;
  width: 34px;
}

.crm-empty-state strong {
  font-size: 14px;
  font-weight: 800;
  overflow-wrap: anywhere;
}

.crm-empty-state p {
  color: #7b8499;
  font-size: 13px;
  margin: 0;
  max-width: 420px;
  overflow-wrap: anywhere;
}

.crm-empty-action {
  margin-top: 5px;
}
</style>
